import React, { useEffect, useState } from "react";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import "../../css/chats.css";
import { InterviewType } from "../../interfaces/user";
import { DATE_FORMAT5, TIME_FORMAT1 } from "../../constants/stringConstants";
import { DateFormatter } from "../../functions/commons";
import { isNil } from "lodash";
import CompanyAvatar from "../Avatars/CompanyAvatar";

type InterviewItemPropsType = {
  data: InterviewType;
  fromJobSec?: boolean;
};

function ChatCard(props: InterviewItemPropsType) {
  const { data, fromJobSec } = props;

  const { jobApplication, date, startTime } = data;
  const { companyJob } = jobApplication;
  return (
    <div className={`chat_card ${fromJobSec ? "chat_card_job_sec" : ""}`}>
      <div>
        {!isNil(companyJob.company.companyLogo) ? (
          <div className="chat_image_icon_container">
            <img
              // className="chat_image_icon"
              // src={
              //   "https://01hiredata.s3.eu-central-1.amazonaws.com/attachments/259fe68c-7ed7-494c-a175-cb700527224d.jpeg"
              // }
              src={companyJob.company.companyLogo}
              height="40"
              width="40"
              style={{ borderRadius: "100%" }}
            />
          </div>
        ) : (
          <CompanyAvatar />
        )}
        <div className="leftNavChatTileSec">
          <div className="chat_tile_name_message">
            <text>{companyJob.company.companyName}</text>
            <text>Message</text>
          </div>
        </div>
      </div>
      <div className="chat_schedule_container">
        <div>
          <CalendarMonthOutlinedIcon
            style={{
              height: "22px",
              width: "22px",
              marginRight: "10px",
            }}
          />
          <text>{DateFormatter(date, DATE_FORMAT5)}</text>
        </div>

        <div>
          <QueryBuilderIcon
            style={{
              height: "22px",
              width: "22px",
              marginRight: "10px",
            }}
          />
          <text>{DateFormatter(startTime, TIME_FORMAT1)}</text>
        </div>
      </div>
    </div>
  );
}

ChatCard.defaultProps = {
  fromJobSec: false,
};

export default ChatCard;
